// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
  $('#wrapper').addClass('setTouch');
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
// $(function () {
//   // setScroll();
//   // if ($('#wrapper').hasClass('home')) {
//   //   setWave();
//   // }
//   // ///////////
//   // if (!_ua.Mobile && !_ua.Tablet) {
//   //   $('#wrapper').addClass('desktop');
//   //   if (!$('#wrapper').hasClass('about')) {
//   //     $('html, body').prop({
//   //       scrollTop: 0,
//   //     });
//   //     if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
//   //       // ここにSafari用の記述
//   //     } else {
//   //     }
//   //   }
//   // }
//   // ///////////
// });

$(window).on('load', function () {
  judgeWinSize();
  setHeader();
  setSpan();
  // setInview();
  setAcc();
  // setMegaMenu();
  // smoothScroll();
  setSmooth();
  setMainMenu();
  setLoaded();
  setWay();
  mailTo();
  heightLineGroup();
  // setBlobsSlide(6000);
  if ($('#wrapper').hasClass('business')) {
    // setGsap();
    // setSlider_01();
    setNewGallery();
  } else if ($('#wrapper').hasClass('products')) {
    productLink();
  } else if ($('#wrapper').hasClass('contact')) {
    setForm();
  } else if ($('#wrapper').hasClass('team')) {
    $('#cont_01').find('.toggleBtn').click();
    setAnchorNav();
  } else if ($('#wrapper').hasClass('philosophy')) {
    setRellax();
  } else if ($('#wrapper').hasClass('company')) {
    setHistoryHover();
  }
});

var current_scrollY = 0;

//新ギャラリー
function setNewGallery() {
  var link = $('.customGallery .btn'); // aタグ要素代入
  if (_ua.Mobile) {
    link.on('touchstart', function () {
      $(this).closest('.item').addClass('is-hover');
    });
    link.on('touchend', function () {
      $(this).closest('.item').removeClass('is-hover');
    });
  } else {
    $('.customGallery .btn').hover(
      function () {
        // マウスが.hoverしたとき、親の.itemに.is-hoverクラスを追加
        $(this).closest('.item').addClass('is-hover');
      },
      function () {
        // マウスが離れたとき、親の.itemから.is-hoverクラスを削除
        $(this).closest('.item').removeClass('is-hover');
      }
    );
  }
}

//historyの画像hover
function setHistoryHover() {
  var link = $('.historyHover'); // aタグ要素代入
  if (_ua.Mobile) {
    link.on('touchstart', function () {
      $(this).closest('.item').addClass('is-hover');
    });
    link.on('touchend', function () {
      $(this).closest('.item').removeClass('is-hover');
    });
  } else {
    $('.historyHover').hover(
      function () {
        // マウスが.hoverしたとき、親の.itemに.is-hoverクラスを追加
        $(this).closest('.item').addClass('is-hover');
      },
      function () {
        // マウスが離れたとき、親の.itemから.is-hoverクラスを削除
        $(this).closest('.item').removeClass('is-hover');
      }
    );
  }
}

///
function setAnchorNav() {
  var $win = $(window);
  var $anchor = $('#anchor');
  var $anchorItem = $anchor.find('li');
  var anchorItemLength = $anchorItem.length;
  var offsetArray = [];
  var currentAnchorIndex = null;
  var offsetAdjust = 30;
  var currentClassName = 'is-current';

  // 初期化
  function init() {
    // アンカーリンクの設定されたセクションのoffset.top値を配列に格納
    $anchorItem.each(function (i) {
      var sectionID = $(this).find('a').attr('href');
      offsetArray[i] = $(sectionID).offset().top - offsetAdjust;

      // 最後のセクションの末尾のoffset.top値をendプロパティに設定
      if (i === anchorItemLength - 1) {
        offsetArray['end'] = $(sectionID).offset().top - offsetAdjust + $(sectionID).height();
      }
    });

    // スクロール時にcheckScrollTopを実行
    $win
      .on('scroll', function () {
        checkScrollTop();
      })
      .trigger('scroll');
  }

  // スクロール量をチェックしchangeCurrentNavを実行
  function checkScrollTop() {
    for (var i = offsetArray.length - 1; i >= 0; i--) {
      if ($win.scrollTop() >= offsetArray[i]) {
        changeCurrentNav(i);
        break;
      }
    }

    // 最初のセクションに到達していない場合と
    // 最後のセクションの末尾に到達した場合はカレント表示を消す
    if ($win.scrollTop() < offsetArray[0] || $win.scrollTop() > offsetArray['end']) {
      changeCurrentNav(null);
    }
  }

  // カレント表示を変更
  function changeCurrentNav(index) {
    if (index !== currentAnchorIndex) {
      $anchorItem.removeClass(currentClassName);
      if (index !== null) {
        $anchorItem.eq(index).addClass(currentClassName);
      }
      currentAnchorIndex = index;
    }
  }
  init();
}

// /////フォーム制御
function setForm() {
  $('.wpcf7-tel').attr('pattern', '\\d*');
  $('.wpcf7-tel').attr(
    'onkeyup',
    'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")'
  );

  $('.optSec').on('click', function (event) {
    event.stopPropagation();
    $(this).toggleClass('is-check');
    $('#confirmBtn').toggleClass('dis');
  });

  $('.optSec a').on('click', function (event) {
    event.stopPropagation();
  });
  // $('input[name="acceptance-form"]').change(function () {
  //   var prop = $(this).prop('checked');
  //   if (prop) {
  //     $('#confirmBtn').removeClass('off');
  //   } else {
  //     $('#confirmBtn').addClass('off');
  //   }
  // });

  // $('#js-count').keyup(function () {
  //   var count = $(this).val().length;
  //   $('.show-count').text(count);
  // });

  $('#confirmBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7-previous').click();
  });
  $('#sendBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  /////エラーのとき
  document.addEventListener(
    'wpcf7invalid',
    function (event) {
      setTimeout(function () {
        var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
        $('html,body').animate(
          {
            scrollTop: position,
          },
          {
            queue: false,
          }
        );
      }, 100);
    },
    false
  );
  // // /////成功のとき
  // document.addEventListener(
  //   'wpcf7mailsent',
  //   function (event) {
  //     $('html,body').animate(
  //       {
  //         scrollTop: 0,
  //       },
  //       {
  //         queue: false,
  //       }
  //     );
  //   },
  //   false
  // );

  // var urlHash = location.search;
  // // URLにアンカーが存在する場合
  // if (urlHash) {
  //   urlHash = urlHash.replace('?subject_', '');
  //   var target = '.subjectSelect .wpcf7-list-item:nth-child(' + urlHash + ') label';
  //   target = $(target);
  //   target.click();
  // }
}

//Productsクリック
function productLink() {
  $('.productsWrap .item').on('click', function () {
    if (!$(this).hasClass('active')) {
      $('.productsWrap .item').removeClass('active');
      $(this).addClass('active');
    } else {
      $('.productsWrap .item').removeClass('active');
    }
  });
}

//Gsap
function setGsap() {
  gsap.registerPlugin(ScrollTrigger);
  // 複数のターゲットとトリガーを取得
  const gsapImgs = document.querySelectorAll('.gsapImg_01');
  const gsapWraps = document.querySelectorAll('.gsapWrap_01');

  gsapImgs.forEach((img, index) => {
    gsap.to(img, {
      // scale: 850 / 170,
      scale: 850 / 1,
      // opacity: 1,
      duration: 1, // アニメーションの持続時間（秒）
      // delay: 0.1,
      delay: 0,
      ease: 'power4.in', // イージングの種類
      scrollTrigger: {
        trigger: gsapWraps[index],
        start: 'top 50%',
        // end: 'bottom 10%',
        toggleActions: 'play none none none',
        // scrub: true,
        markers: true,
        once: true,
      },
    });
  });
}

//スクロールヒント
function setScrollHint() {
  $('.scrollHintSec').scroll(function () {
    $(this).parent().find('.scroll-hint-icon-wrap').fadeOut();
    // スクロールしたときの処理内容を記述する
  });
  // new ScrollHint('.js-scrollHint', {
  //   i18n: {
  //     scrollable: 'スクロールできます',
  //   },
  // });
}

//メアドスパム対策
function mailTo() {
  $('.mailTo').click(function () {
    var address = $(this).attr('href').replace('+', '@');
    location.href = 'mailto:' + address;
    return false;
  });
}

// Rellax
function setRellax() {
  var rellax = new Rellax('.js-rellax');
}

// カルーセル
function setSlider_01() {
  const mySwiperMain = new Swiper('.carouselStyle_01 .swiper-main', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchSlidesProgress: true,
    loop: true,
    effect: 'fade',
    // preventClicks: false,
    // preventClicksPropagation: false,
    // autoplay: {
    //   // 自動再生
    //   delay: 2000, // 1.5秒後に次のスライド
    //   disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    //   waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    // },
    mousewheel: {
      forceToAxis: true,
    },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   draggable: true,
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, // クリック有効化
      type: 'fraction',
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    // breakpoints: {
    //   769: {
    //     slidesPerView: 5,
    //     spaceBetween: 36,
    //   },
    //   // 1000: {
    //   //   slidesPerView: 3,
    //   //   spaceBetween: 30,
    //   // },
    // },
  });

  // サムネイルのクリックイベントを設定
  const thumbnails = document.querySelectorAll('.carouselStyle_01 .swiperThumb li');
  thumbnails.forEach(function (thumbnail, index) {
    thumbnail.addEventListener('click', function () {
      $('.gallerySec').addClass('swiper-active');
      mySwiperMain.slideTo(index + 1);
    });
  });

  $('footer,.gallerySec .swiper-slide,.gallerySec .imgStyle,.gallerySec .head').on(
    'click',
    function () {
      $('.gallerySec').removeClass('swiper-active');
    }
  );
  $('#container,.secStyle_01,.gallerySec').on('click', function (event) {
    if (event.target === this) {
      $('.gallerySec').removeClass('swiper-active');
    }
  });
}

// //////////////////////////メインメニュー
function setMainMenu() {
  $('#menuBtn').on('click', function () {
    if (!$('#menuBtn').hasClass('active')) {
      openFnc();
    } else {
      closeFnc();
    }
  });
  $('.menuOpen #clickBlocker,.menuCloseArea,.menuUnq').on('click', function (event) {
    event.stopPropagation();
    closeFnc();
  });

  // $('.mainNav a').on('click', function (event) {
  //   event.stopPropagation();
  // });

  // var winW = $(window).width();
  // var timer = false;
  // var currentWidth = window.innerWidth;
  // window.addEventListener('resize', function () {
  //   winW = $(window).width();
  //   if (currentWidth == window.innerWidth) {
  //     return;
  //   }
  //   currentWidth = window.innerWidth;
  //   if (timer !== false) {
  //     clearInterval(timer);
  //   }
  //   timer = setTimeout(function () {
  //     if (winW > tabletNum) {
  //       closeFnc();
  //     }
  //   }, 200);
  // });
}

function openFnc() {
  current_scrollY = $(window).scrollTop();
  $('#menuBtn').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -current_scrollY);
}

function closeFnc() {
  $('#menuBtn').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  $('html, body').prop({
    scrollTop: current_scrollY,
  });
}

// ///////ヘッダー制御
let set_position = 0;
function setHeader() {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
      $('header').removeClass('fixedHeaderDelay');
    }, 10);
  });

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader() {
    if ($('#wrapper').hasClass('home')) {
      h = $('#mainVis').height();
    } else if ($('#wrapper').hasClass('setKv')) {
      h = $('#kv').height();
    } else {
      h = 5;
    }
    baseHeight = h;
    if ($(this).scrollTop() < baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    } else if ($(this).scrollTop() >= baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
    if (set_position < $(this).scrollTop()) {
      $('#wrapper').addClass('scrollDown');
      $('#wrapper').removeClass('scrollUp');
    } else {
      $('#wrapper').addClass('scrollUp');
      $('#wrapper').removeClass('scrollDown');
    }

    set_position = $(this).scrollTop();
  }
}

// テキストアニメーション用span生成
function setSpan() {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// ///////waypoint
function setWay() {
  $('.way,.way-slow,.alphaWay,.js-way,.autoWay').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.chaineWay').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        timer = setTimeout(function () {
          $('.chaineFoot .chaineBg').addClass('is-active');
        }, 3100);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.js-item-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active-item');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-item-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.video-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      var videoElem = activePoint.find('video');
      if (direction === 'down') {
        videoElem.get(0).play();
      }
    },
    {
      offset: '70%',
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.js-toggle .head').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle(600);
  });

  $('.footer-gNav .accBtn').on('click', function () {
    $(this).parents('.item').toggleClass('is-active');
    $(this).parents('.item').find('.content').stop().slideToggle('fast');
  });

  $('.articleStyle_05 .toggleBtn').on('click', function () {
    $(this).parents('.articleStyle_05').toggleClass('active');
    $(this).parents('.articleStyle_05').find('.paragraphs').stop().slideToggle('fast');
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wrapper,#loading').addClass('loaded');
  loadStart();
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedDone');
  }, 200);
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedStart');
  }, 600);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
    $('#mainVis').addClass('is-active');
  }, 1500);
  timer = setTimeout(function () {
    $('#wrapper').addClass('homeStart');
  }, 1200);
  if ($('#wrapper').hasClass('home')) {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeDelay');
    }, 2200);
  } else {
    timer = setTimeout(function () {
      $('#wrapper').addClass('pagesDelay');
    }, 500);
  }
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

//スムーススクロール改良
function setSmooth() {
  if ($('#wrapper').hasClass('setPc')) {
    // var headH = $('header').outerHeight();
    var headH = 100;
  } else {
    var headH = 0;
  }

  var currentUrl = window.location.href.split('#')[0];
  var animeSpeed = 500; //アニメーションスピード
  $('.menuUnq').on({
    click: function () {
      var hrefBase = $(this).attr('href').split('#')[0];
      var hrefValue = $(this).attr('href');
      if (currentUrl === hrefBase) {
        // フラグメント部分（#以降）を取得
        var fragment = hrefValue.split('#')[1];
        var target = '#' + fragment;
        var position;
        position = $(target).offset().top - headH; //ターゲットまでの距離からヘッダーの高さを引く
        $('body,html').stop().animate(
          {
            scrollTop: position,
          },
          animeSpeed
        );
      }
      // return false;
    },
  });

  //ページ遷移
  var urlHash = location.hash; //URLのハッシュタグを取得
  if (urlHash) {
    //ハッシュタグが有る場合
    $('body,html').scrollTop(0);
    setTimeout(function () {
      //無くてもいいが有ると動作が安定する
      var target = $(urlHash);
      var position = target.offset().top - headH;
      $('body,html').stop().animate(
        {
          scrollTop: position,
        },
        animeSpeed
      );
    }, 0);
  }
}

// /////////////////////////////スムーススクロール
const smoothScroll = () => {
  //スクロールリンク取得
  const targets = document.querySelectorAll('a[href^="#"]:not(.menuUnq)');
  if (targets.length === 0) {
    return;
  }

  //スクロール速度
  const ANIME_SPEED = 600;
  //スクロール移動の実行中にbodyへ付与するclass
  const SCROLL_BUSY_CLASS = 'is-scroll-busy';

  const bodyClassList = document.body.classList;

  /*
    スクロールアニメーションイージング設定
    https://easings.net/ja
  */
  const easing = (x) => {
    //easeInOutQuad
    return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
  };

  //スクロール停止要素取得
  const getScrollStopTarget = (target) => {
    //hrefから遷移先を取得
    const href = target.getAttribute('href');
    let scrollStopTarget = null;
    let selector = href;
    //#top（HTMLの仕様でページの最上部へ戻るアンカーリンク）が手動設定されているかチェック
    //https://html.spec.whatwg.org/multipage/browsing-the-web.html#scroll-to-the-fragment-identifier
    if (href === '#top') {
      scrollStopTarget = document.querySelector(href);
    }
    //#topが手動設定されていない場合はhrefから遷移先を取得
    if (!scrollStopTarget) {
      //#や#topの場合はページの最上部へ戻るbodyを遷移先に設定
      selector = href === '#' || href === '#top' || href === '' ? 'body' : href;
      scrollStopTarget = document.querySelector(selector);
    }
    return scrollStopTarget;
  };

  //アニメーション実行中class削除
  const resetBodyBusyClass = () => {
    bodyClassList.remove(SCROLL_BUSY_CLASS);
  };

  //スクロール停止位置取得
  const getScrollStopPosition = (scrollStopTarget) => {
    //スクロール位置の調整
    //scroll-margin-top、scroll-padding-topを取得。相対値による小数点は四捨五入
    const scrollStopTargetStyles = getComputedStyle(scrollStopTarget);
    const scrollPaddingTop = scrollStopTargetStyles.scrollPaddingTop;
    const shiftPosition =
      Math.round(parseFloat(scrollStopTargetStyles.scrollMarginTop)) +
      Math.round(parseFloat(scrollPaddingTop === 'auto' ? 0 : scrollPaddingTop));
    //移動先取得
    return Math.round(scrollStopTarget.getBoundingClientRect().top) - shiftPosition;
  };

  //フォーカス移動
  const changeFocus = (scrollStopTarget) => {
    scrollStopTarget.focus();
    //ターゲット要素がフォーカス可能な要素以外の場合
    if (document.activeElement !== scrollStopTarget) {
      scrollStopTarget.setAttribute('tabindex', '-1');
      scrollStopTarget.focus();
      //フォーカスアウトラインを非表示
      scrollStopTarget.style.outline = 'none';
    }
  };

  //スクロール終了処理
  const endFunc = (scrollStopTarget) => {
    //アニメーション実行中class削除
    resetBodyBusyClass();
    //フォーカス移動
    changeFocus(scrollStopTarget);
  };

  //スクロールアニメーション
  const raf = requestAnimationFrame;
  const scrollAnime = (scrollStopTarget, scrollStopPosition) => {
    //現在のスクロール量
    const scrollTop = window.scrollY;

    //アニメーション開始時間
    let startTime;

    //アニメーション関数
    const startAnime = (timestamp) => {
      //イベント発生後の経過時間
      // startTime未定義時のみtimestampを代入することで一度だけstartTimeに数値を格納する
      if (startTime === undefined) {
        startTime = timestamp;
      }

      // 経過時間を監視
      const elapsedTime = timestamp - startTime;

      //アニメーション終了処理
      if (elapsedTime > ANIME_SPEED) {
        endFunc(scrollStopTarget);

        //処理を終了
        return;
      }

      //進捗度を算出してイージングを適用
      //elapsedTimeを0からANIME_SPEEDの値で正規化（0〜1の値に変換）
      const elapsedTimeNorm = elapsedTime / ANIME_SPEED;

      //位置設定
      const scrollY = scrollTop + scrollStopPosition * easing(elapsedTimeNorm);

      //スクロール処理
      window.scrollTo(0, scrollY);
      //アニメーション関数再実行
      raf(startAnime);
    };

    //初回アニメーション呼び出し
    raf(startAnime);
  };

  //クリックイベント設定
  targets.forEach((target) => {
    target.addEventListener('click', (event) => {
      event.preventDefault();

      //スクロール停止要素取得
      const scrollStopTarget = getScrollStopTarget(target);

      //遷移先が存在しない場合は処理しない
      if (!scrollStopTarget) {
        resetBodyBusyClass();
        return;
      }

      //スクロールイベント重複防止
      if (bodyClassList.contains(SCROLL_BUSY_CLASS)) {
        return;
      }
      bodyClassList.add(SCROLL_BUSY_CLASS);

      //スクロール停止位置取得
      const scrollStopPosition = getScrollStopPosition(scrollStopTarget);

      //視差効果を減らす設定がある場合はアニメーションしない
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, scrollStopPosition);
        endFunc(scrollStopTarget);
      } else {
        scrollAnime(scrollStopTarget, scrollStopPosition);
      }
    });
  });
};

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

function watchViewMode() {
  window.addEventListener('orientationchange', function () {
    // orientationchange イベントがトリガーされたときの処理をここに記述します
    location.reload(); // ページをリロードします
  });
}
// //////////////////////////////高さ揃え
function heightLineGroup() {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  setAutoHeight('.setH_01');
  setAutoHeight('.setH_02');
  // var winW = $(window).width();
  // if (winW > breakNum) {
  //   setAutoHeight('.setH_01', 3);
  // } else {
  //   setAutoHeight("#setH_08 h2",2)
  // }
  setAutoHeight('.setH_04', 2);

  startResize();
}

function setAutoHeight(target, count) {
  $(target).tile(count);
}

function startResize() {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
